import React, { FunctionComponent, useState } from "react";
import styles from "./LiveTrackingModal.module.css";
import Modal from "react-modal";
import { useEffect } from "react";
import {fetchOrganizationUsersList,fetchOrganizationTrackingUsers,saveOrganizationTrackingLicenses, fetchOrganizationUsersListMongo, fetchOrganizationTrackingUsersMongo } from "../../../Services/users";
import { useDispatch } from "react-redux";
import Loading from "../../Loading/Loading";
import { themeColors } from "../../theme";
import { motion, AnimatePresence } from "framer-motion";
import Backdrop from "../../Backdrop/Backdrop";
import { connect } from 'react-redux';
import { IoIosClose } from "react-icons/io";

type props = {
  open: boolean;
  close: () => void;
  organizationId:any;
  theme:any;
//   branchList: any[];
//   uid: string;
};

const dropIn = {
    hidden: {
      y: "-100vh",
      opacity: 1,
    },
    visible: {
      y: "0",
      opacity: 1,
      transition: {
        duration: 1,
        type: "spring",
        damping: 25,
        stiffness: 500,
      },
    },
  };

const LiveTrackingModal: FunctionComponent<props> = ({
  open,
  close,
  organizationId,
  theme
//   branchList,
//   uid,
}) => {
  const [usersList, setUsersList] = useState<any[]>([]);
  const [organization, setOrganization] = useState<any[]>([]);
  const [load, setLoad] = useState(false);
  const dispatcher = useDispatch();

  useEffect(() => {
    fetchOrganizationUsersListMongo(organizationId,setUsersList);
    fetchOrganizationTrackingUsersMongo(organizationId,setOrganization);
  }, []);

  const onCheck = (event: any, value: any) => {
    if (value === "All") {
      if (event.target.checked) {
        let data:any = ["All"];
        setOrganization(["All"]);
      } else if (!event.target.checked) {
        let data:any = [];
        setOrganization(data);
      }
    } else {
        let item = organization.indexOf("All");
        if (item > -1) {
            organization.splice(item, 1);
        }
      if (event.target.checked) {
        let data:any = [...organization];
        data.push(value.uid);
        setOrganization(data);
      } else if (!event.target.checked) {
        let data:any = [...organization];
        let item = organization.indexOf(value.uid);
        if (item > -1) {
          data.splice(item, 1);
        }
        setOrganization(data);
      }
    }
  };

//   const searchUser = (searchString:any) => {
//     const regex = new RegExp(searchString, "i"); 
//     let filteredList = usersList.filter(
//       (obj) => regex.test(obj.user_first_name) || regex.test(obj.user_email)
//     );
//     setUsersList(filteredList);
//   }

  const onsave = () => {
    setLoad(true);
    saveOrganizationTrackingLicenses(
      organizationId,
      organization,
      dispatcher,
      setLoad,
      close
    );
  };

  const customStyles = {
    content: {
      backgroundColor: theme ? themeColors.dropdownBackgroundColor : themeColors.dropdownBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark
    },
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  return (
<>
{load === true && <Loading />}
<Backdrop>
  <motion.div
    key="modal"
    className="card p-4 shadow rounded"
    style={{
      position: "absolute",
      ...containerStyles,
      minWidth: "400px"
    }}
    variants={dropIn}
    initial="hidden"
    animate="visible"
    exit="exit"
  >
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: "1rem" }}>
      <h6
      // className={styles.heading}
      >Select Users</h6>
      <div className={styles.icon} onClick={close}>
        <IoIosClose size={35} color={"#808080"} />
      </div>
    </div>
{/* 
    <div className="input-group rounded border mt-2">
  <input type="search" className="form-control rounded border-0" placeholder="search user" aria-label="search user" aria-describedby="search-addon" onChange={(e)=>{
    searchUser(e.target.value)
  }} />
  <span className="input-group-text border-0 bg-white" id="search-addon">
    <i className="fas fa-search"></i>
  </span>
</div> */}

     <div style={{maxHeight:"300px",overflowY:'scroll'}}>
        <div className={styles.detail}>
                <input
                type="checkbox"
                onChange={(e) => {
                    onCheck(e, "All");
                }}
                checked={organization.includes("All") ? true : false}
                />
                <p className={styles.option}>All</p>
            </div>
        {usersList.length !== 0 ? (
            usersList.map((item, index) => (
            <div key={index} className={styles.detail}>
                <input
                type="checkbox"
                onChange={(e) => {
                    onCheck(e, item);
                }}
                checked={organization.includes(item.uid) ? true : false}
                />
                <p className={styles.option}>{item.user_email}</p>
            </div>
            ))
        ) : (
            <h6 className="text-center mt-2">No User Data Available</h6>
        )}
     </div>

    <div className={styles.buttonView}>
        <button className={styles.cancelButton} onClick={close}>
          Cancel
        </button>
        <button className={styles.saveButton} onClick={onsave}>
          Save
        </button>
      </div>
  </motion.div>
</Backdrop>
</>
  );
};

const mapStateToProps = (state: any) => {
    return {
      user: state.user.data,
      theme: state.theme.isLightMode
    };
  };
  export default connect(mapStateToProps)(LiveTrackingModal);
